import { render } from "./WhatsApp.vue?vue&type=template&id=91536df4"
import script from "./WhatsApp.vue?vue&type=script&lang=js"
export * from "./WhatsApp.vue?vue&type=script&lang=js"

import "./WhatsApp.vue?vue&type=style&index=0&id=91536df4&lang=css"
script.render = render

export default script